export const SN_ORDER = 'order'
export const ORDER_LIST_UPDATED = SN_ORDER + '/LIST_UPDATED'
export const ORDER_SELECTED_ITEMS_UPDATED = SN_ORDER + '/SELECTED_ITEMS_UPDATED'